import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    margin: 0 24px;
    padding: 0px 0px 24px;

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      margin: 0px;
    }
  `}
`;

export const CardsContainer = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v3.colors.neutral[100]};
    padding: 32px;

    @media (max-width: ${theme.v3.breakpoints.lg}) {
      padding: 24px 20px;
    }
  `}
`;

export const CardsTitle = styled.h2`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[20]};
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes.large};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.relaxed};
    margin: 0px;
  `}
`;

export const CardsDescription = styled.p`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[40]};
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin: 32px 0px 0px;
  `}
`;

export const CardsWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 24px;
    justify-content: flex-start;
    margin: 32px 0px 0px;

    @media (max-width: ${theme.v3.breakpoints.lg}) {
      align-items: center;
      flex-direction: column;
      gap: 32px;
    }
  `}
`;

export const Card = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background: ${theme.v3.colors.neutral[100]};
    border-radius: ${theme.v3.border.radius.round};
    border: ${theme.v3.border.width.thin} solid ${theme.v3.colors.neutral[95]};
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    flex: 1 0 0;
    gap: 24px;
    height: 350px;
    min-width: 280px;
    padding: 24px;
    position: relative;
    width: 415.33px;
  `}
`;

export const CardOuterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 280px;
  width: 415.33px;
`;

export const CardTagsWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: center;
  position: absolute;
  right: 24px;
  top: 0;
  transform: translateY(-50%);
`;

export const CardTag = styled.span`
  ${({ theme }) => css`
    align-items: center;
    background: ${theme.v3.colors.brand.snappyBlue[95]};
    border-radius: ${theme.v3.border.radius.sm};
    color: ${theme.v2.colors.brand.primaryExtraDark};
    display: flex;
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.medium};
    height: 24px;
    justify-content: center;
    line-height: ${theme.v3.font.lineHeight.comfortable};
    padding: 0 8px;
    white-space: nowrap;
  `}
`;

export const CardTagRecommended = styled.span`
  ${({ theme }) => css`
    align-items: center;
    background: ${theme.v3.colors.accent.green[70]};
    border-radius: ${theme.v3.border.radius.sm};
    color: ${theme.v3.colors.brand.snappyBlue[98]};
    display: flex;
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.medium};
    height: 24px;
    justify-content: center;
    line-height: ${theme.v3.font.lineHeight.comfortable};
    padding: 0 8px;
    white-space: nowrap;
  `}
`;

export const CardImageWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const CardImage = styled.img`
  display: block;
`;

export const CardTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CardTitle = styled.span`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[20]};
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes['1xmedium']};
    font-weight: ${theme.v3.font.weights.bold};
    line-height: ${theme.v3.font.lineHeight.relaxed};
  `}
`;

export const CardSubtitle = styled.span`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[40]};
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
  `}
`;

export const CardList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 16px;
  list-style: none;
  margin: 0px;
  padding: 0px;
  width: 100%;
`;

export const CardListItem = styled.li`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[40]};
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};

    strong {
      color: ${theme.v3.colors.neutral[20]};
      font-weight: ${theme.v3.font.weights.medium};
    }
  `}
`;

export const CardActionWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: auto;
  width: 100%;
`;

export const SelectOptionWrapper = styled.div`
  display: flex;
  gap: 16px;

  span {
    display: block;
    max-width: 218px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  div {
    display: inline-flex;
    position: relative;
  }
`;
